<script setup>
const items = [
  {id: 'lamb', title: 'ягнёнок', color: '#779C5A', textColor: '#2C452A'},
  {id: 'salmon', title: 'лосось', color: '#E18E6A', textColor: '#602D1A'},
  {id: 'chicken', title: 'Курица', color: '#F7A833', textColor: '#705027'}
]
</script>
<template>
  <div class="protein-info">
    <div class="protein-info__inner">
      <h2 class="protein-info__title">РАЗНООБРАЗИЕ ИСТОЧНИКОВ БЕЛКА</h2>
      <p class="protein-info__subtitle">Рационы приготовлены с&nbsp;сохранением важнейших питательных веществ и&nbsp;вкуса</p>
      <div class="protein-info__wrap">
        <div class="protein-info__items">
          <div :class="['protein-info__item', `_${item.id}`]" v-for="item in items" :key="item.id">
            <svg width="240" height="407" viewBox="0 0 240 407" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
              <path d="M240 0L0 0L0.000133514 369.524L240 407L240 0Z" :fill="item.color"/>
            </svg>
            <div>
              <div class="protein-info__item-image">
                <img :src="require(`@/assets/img/icon-${item.id}.svg`)" alt=""/>
              </div>
              <h4 :style="{'color': item.textColor}"><span>№1</span>
                Ингредиент<br/>
                в составе<sup>*</sup></h4>
              <p>{{ item.title }}</p>
            </div>
          </div>
        </div>
        <p><sup>*</sup>В составе сухих рационов PRO&nbsp;PLAN<sup>®</sup> для щенков</p>
      </div>
    </div>
  </div>
</template>